import { Injectable } from '@angular/core';
import { ResourceCRUD, ResourceParams, ResourceMethod, ResourceAction } from 'ng2-resource-rest';
import {
    Customer,
    ICustomer
} from './customer';
import { RequestMethod } from '@angular/http';
import { DateString } from './types';
import { IOrder } from './payment';

interface ISearchInput {
    start? : DateString;
    stop?  : DateString;
}

interface IByIdsInput {
    ids? : number[];
}

interface IByInvoiceInput {
    id : number;
    hash: string;
}

export interface IReservationRowData {
    type        : string;
    quantity    : number;
}

export interface IReservationRow {
    reservationId   : number;
    date            : DateString;
    time            : string;
    data            : IReservationRowData[];
}

export interface IReservationShort {
    id?         : number;
    reserver    : ICustomer;
    startDate   : DateString|Date;
    title       : string;
    info        : string;
    status      : number;
    type        : string;
}

export interface IReservation extends IReservationShort {
    balls? : number;
    pumps? : number;
    hours? : number;
    time?  : string;
    car?   : boolean;
    pickUp?: boolean;
    delivery?: boolean;
    order?: IOrder;
    canReserve? : boolean;
    staff? : boolean;
}

@Injectable()
@ResourceParams({
    url: '/api/reservation'
})
export class Reservation extends ResourceCRUD<ISearchInput, IReservationShort, IReservation> {

    public static newReservation(date : Date) : IReservation {
        return {
            reserver: Customer.newCustomer(),
            startDate: date,
            title: '',
            info: '',
            status: 0,
            type: '',
            time: 'TIME_MORNING'
        };
    }

    @ResourceAction({
        isArray: true,
        method: RequestMethod.Post
    })
    public search: ResourceMethod<ISearchInput, IReservationRow[]>;

    @ResourceAction({
        isArray: true,
        path: '/by-ids',
        method: RequestMethod.Post
    })
    public byIds: ResourceMethod<IByIdsInput, IReservation[]>;

    @ResourceAction({
        path: '/save',
        method: RequestMethod.Post
    })
    public save: ResourceMethod<IReservation, IReservation>;

    @ResourceAction({
        path: '/by-invoice',
        method: RequestMethod.Post
    })
    public getByInvoice: ResourceMethod<IByInvoiceInput, IReservation>;

    @ResourceAction({
        path: '/check',
        method: RequestMethod.Post
    })
    public check: ResourceMethod<IReservation, {status: string}>;

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/model/reservation.ts